export const DISCORD_URL = 'https://discord.com/invite/4aWJV3t85w'

export const TWITTER_URL = 'https://twitter.com/IntegralHQ'

export const DEFI_PULSE_URL = 'https://defipulse.com/integral'

export const GITBOOK_URL = 'https://docs.integral.link'

export const GITHUB_URL = 'https://github.com/IntegralHQ/Integral-FIVE-Smart-Contracts'

export const INTEGRAL_ABOUT_URL = 'https://integral.link'

export const INTEGRAL_DOCS_URL = 'https://docs.integral.link'

export const INTEGRAL_TOKEN_URL = 'https://docs.integral.link/token'

export const INTEGRAL_SUPPORT_URL = 'mailto:support@integral.link'

export const INTEGRAL_CAREERS_URL = 'https://integral-link.breezy.hr/'

export const INTEGRAL_TERMS_URL = 'https://integral.link/legal/terms-of-use'

export const INTEGRAL_PRIVACY_URL = 'https://integral.link/legal/privacy-policy'

export const INTEGRAL_LP_FARMING_URL = 'https://docs.integral.link/size/token/lp-farming'

export const INTEGRAL_APP_SIZE_URL = 'https://size.integral.link'

export const INTEGRAL_DOCS_FIVE_URL = 'https://docs.integral.link/five/'
